import script from "./SubscriptionPush.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionPush.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionPush.vue?vue&type=style&index=0&id=8a2fc236&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8a2fc236"]])

export default __exports__